import React from 'react';
import { useSelector } from 'react-redux';
import { getProjectState } from 'app/stores/project';
import { EditTextCloud } from 'app/views/components/editor/tools/edit/text/EditCloud';
export const EditText = () => {
    const markerBackground = useSelector(state => {
        const project = getProjectState(state);
        const selectedItemId = project.selection[0];
        if (!selectedItemId) {
            return undefined;
        }
        const textMarker = project.markers[selectedItemId];
        return textMarker.background;
    });
    if (markerBackground) {
        switch (markerBackground.type) {
            case 'cloud':
                return React.createElement(EditTextCloud, null);
            default:
                break;
        }
    }
    return null;
};
